import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import uuid from 'uuid'
import { withRouter } from 'react-router'
import { reduxForm, reset, getFormValues } from 'redux-form'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import queryString from 'query-string'

function decorator(config) {
  return ComposedComponent => {
    @reduxForm(
      {
        form: config.form,
        destroyOnUnmount: !config.persist
      },
      { reset }
    )
    @connect(state => ({
        filterFormValues: getFormValues(config.form)(state)
      }),
      { push })
    @withRouter
    class Filter extends Component {
      static propTypes = {
        setFilter: PropTypes.func.isRequired,
        setInitialParams: PropTypes.func,
        disablePersistedFilter: PropTypes.bool,
        query: PropTypes.string,
        change: PropTypes.func,
        handleSubmit: PropTypes.func,
        pristine: PropTypes.bool,
        initialize: PropTypes.func,
        destroy: PropTypes.func,
        push: PropTypes.func,
        options: PropTypes.object,
        router: PropTypes.object,
        routes: PropTypes.array,
        location: PropTypes.object,
        reset: PropTypes.func,
        route: PropTypes.object,
        filterFormValues: PropTypes.object
      }

      componentDidMount() {
        const { filterFormValues } = this.props

        const query = queryString.parse(get(this.props, 'location.search'))

        let filterQuery =
          get(query, 'filter') && JSON.parse(query.filter)

        if (!filterQuery) {
          filterQuery = filterFormValues
        }

        if (!filterQuery && config.defaultFilter) {
          filterQuery = config.defaultFilter
        }

        filterQuery = filterQuery || {}

        this.handleFilterCreate(filterQuery)
        this.props.initialize(filterQuery)
      }

      componentWillUnmount = () => {
        if (!config.persist) {
          this.props.setFilter('')
          this.props.destroy(config.form)
        }
      }

      key = uuid.v1()

      reduceFields = fields => {
        const { options = {} } = this.props

        let newFields = {}

        Object.keys(fields).forEach(key => {
          if (fields[key]) {
            newFields = {
              ...newFields,
              [key]: options[key]
                ? options[key][0].label
                : this.handleFormatMultiWord(fields[key])
            }
          }
        })
        return newFields
      }

      createFilters = o => {
        return Object.keys(o)
          .map(key => {
            // strip operator out
            const parsedKey = key.split('@')[0]

            // set operator or use default
            const operator = key.split('@')[1] ? ` ${key.split('@')[1]} ` : '='

            // get value
            let value = o[key]

            if (typeof value === 'string') {
              value = value.trim()
            }

            if (typeof value === 'number') {
              value = String(value)
            }

            if (Array.isArray(value)) {
              if (operator.trim() === 'or') {
                const values = value.map(
                  item => `${parsedKey.underscoresToDots()}=${item.value}`
                )

                return `or(${values.join(',')})`
              }

              value = value.map(item => item.value).join(',')
            }

            value = value.replace(/,/g, '\\,')

            // change bools to numbers
            switch (value) {
              case 'true':
                value = 1
                break
              case 'false':
                value = 0
                break
              default:
                value = encodeURIComponent(value)
            }

            // is || function
            if (parsedKey.includes('||')) {
              const orParts = parsedKey.split('||')

              let orQuery = []

              orParts.forEach(item => {
                orQuery = orQuery.concat(
                  `${item.underscoresToDots()}${operator}${value}`
                )
              })

              return `or(${orQuery.join(',')})`
            }

            // return filter key=value
            return `${parsedKey.underscoresToDots()}${operator}${value}`
          })
          .join(',')
      }

      createLabel = key => {
        const keys = key.split('.')

        return keys[keys.length - 1]
          .replace(/([A-Z])/g, ' $1')
          .replace(/^./, str => str.toUpperCase())
      }

      mapToFields = (fields, field) => {
        let newFields = {}

        fields.map(item => {
          newFields = Object.assign({}, newFields, item)
        })

        this.props.change(field.dotsToUnderscores(), null)
        this.handleFilterCreate(newFields)
      }

      handleFilterCreate = fields => {
        const reducedFields = this.reduceFields(fields)

        const query = this.createFilters(reducedFields)

        this.handleSetFilter(query, fields)
      }

      handleSetFilter = (query, fields) => {
        const { location, disablePersistedFilter } = this.props

        !disablePersistedFilter &&
        this.props.push({
          ...location,
          pathname: location.pathname,
          query:
            query && fields
              ? {
                filter: JSON.stringify(fields)
              }
              : ''
        })

        if (!query) {
          this.props.destroy(config.form)
        }

        this.props.setFilter(query)
      }

      handleFormatMultiWord = word => {
        if (typeof word === 'string') {
          return word.replace(/\s/gi, '% ')
        }
        return word
      }

      render() {
        const { query, handleSubmit } = this.props

        let tags = query ? query.split(',') : []

        tags = tags.map(tag => {
          return {
            id: tag.split('=')[0],
            label: this.createLabel(tag.split('=')[0]),
            value: tag.split('=')[1]
          }
        })

        return (
          <form key={this.key} onSubmit={handleSubmit(this.handleFilterCreate)}>
            <ComposedComponent
              {...this.props}
              query={query}
              tags={tags}
              onQueryUpdate={this.mapToFields}
              setFilter={this.handleSetFilter}
            />
          </form>
        )
      }
    }

    return Filter
  }
}

export default decorator
